import $ from 'jquery'

export default {
    name: 'examens',
    components: {},
    props: [
        "consultation_id", "protocole_id", "demande_examens", "hn", 
        "etat_traitement", "p_soignant", "jn", "can_show_empty"
    ],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            resultat_examen: {},

            asset_url: '',
            can_view: false,
            to_be_deleted: {},
            del_loading: false,
            is_confirm: false,
        }
    },

    watch: {
        demande_examens() {
            this.getDemandeExamens()
        }  
    },

    computed: {
        /**
         * User Info
         * @returns
         */
         userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.asset_url = this.assets_path + '/files'

        this.getDemandeExamens()
    },

    methods: {
        getDemandeExamens() {
            this.is_loading = true
            if (this.demande_examens.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            setTimeout(() => {
               this.is_loading = false 
            }, 500);
        },

        /**
         * View result
         */
         viewResult(demande_examen) {
            this.resultat_examen = {
                id: demande_examen.id,
                resultat: demande_examen.resultat,
                examen: demande_examen.nom,
                est_disponible: (demande_examen.resultat != null)?true:false
            }
            console.log(this.resultat_examen)
        },

        deleteExamen(exm) {
            
            this.to_be_deleted = {
                id: exm.id,
                examen: exm.nom
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                consultation_id: this.consultation_id,
                protocole_id: this.protocole_id,
                examen_id: this.to_be_deleted.id
            }

            console.log(data)
            this.$store.dispatch('deleteDemandeExamenForHn', data).then((response) => {
                if (response > 0) {
                    this.successToast("Examen supprimé avec succès")
                    this.$emit('emitProtocole', this.jn)

                    this.is_confirm = false
                    this.$refs.examenDelModal.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },
    }
}